import React from 'react';

// "Test environment" notice — shown only against the local test stack (MARKET_API_IS_LOCAL).
export default function PreviewBanner({ text, isAr }) {
  return (
    <div data-preview-banner="1" style={{ background: '#FFF8E6', border: '1px solid rgba(154,118,54,0.35)', color: '#7A5A22', borderRadius: 12,
      padding: '9px 14px', margin: '0 0 14px', fontSize: 12.5, fontWeight: 600,
      fontFamily: isAr ? 'var(--font-ar)' : 'var(--font-sans)', textAlign: isAr ? 'right' : 'left' }}>
      {text}
    </div>
  );
}
